import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export default class Decrypt extends Model {
  //获取报告页秘钥
  static get(param: { candidateId: string }) {
    return request.post("aiExam/candidate/getSid", param).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
}
